/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable con */
import React from "react";
import * as R from "ramda";
import {
  all,
  call,
  fork,
  put,
  select,
  take,
  takeEvery
} from "redux-saga/effects";
import { actions, getters } from "./model";
import { makeFuture } from "utils/General/sagas";
import { showModal } from "redux/modules/modal/actions";
import SendEmailModal from "SendEmailModal/View";
import ModalWrapper from "components/Global/Modal/Wrappers/Black";
import {
  eventDetails as getEventDetails,
  eventId as getEventId
} from "redux/modules/event/selectors";
import { orgId as getOrgId } from "redux/modules/organization/selectors";
import { getCredentials } from "redux/modules/user/selectors";
import { CONTACT_ACTIONS, PAYLOAD } from "./constants";
import { getters as contactGroupGetters } from "EventLight/ContactGroup/model";
import { apiCall } from "App/Data/sagas";
import { registerError } from "redux/modules/errors/actions";
import { showSnackbar } from "redux/modules/snackbar/actions";
import * as STANDARD_MODULE_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-modules";
import { PrimaryContactsModal } from "components/Global/Modals/PrimaryContacts";
import * as SEND_TO_OPTION_TYPES from "SendEmailModal/utils/send-to-option-types";

const DEFAULT_NOTES_PAGE_SIZE = 10;
const moduleId = STANDARD_MODULE_IDS.accounts.id;
const moduleIdForEmails = STANDARD_MODULE_IDS.contacts.id;

const getParams = function*() {
  const eventId = yield select(getEventId);
  const orgId = yield select(getOrgId);
  const credentials = yield select(getCredentials);
  const eventDetails = yield select(getEventDetails);

  return { eventId, credentials, eventDetails, orgId };
};

export const fetchContactDataWithPage = function*({
  payload: { page = 0, pageSize = DEFAULT_NOTES_PAGE_SIZE } = {}
}) {
  // const contactId = R.last(location.pathname.split("/"));
  // const { eventId } = yield call(getParams);
  // const url = `/account/event/${eventId}/${contactId}/contacts`;
  // const options = {
  //   method: "get",
  //   qs: { page, pageSize }
  // };
  // const params = { url, ...options };
  try {
    const { payload } = PAYLOAD;
    const { contacts = [], pagination = {} } = payload;
    yield put(actions.setContactDataData({ contacts, pagination }));
    return true;
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred getting data"
        }
      ])
    );
    return false;
  }
};

const initFetchContactData = function*(url) {
  const options = { method: "get" };
  const params = { url, ...options };
  try {
    const { payload } = PAYLOAD;
    const { contacts = [], pagination = {} } = payload;
    yield put(actions.setContactDataData({ contacts, pagination }));
    return true;
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred getting data"
        }
      ])
    );
    return false;
  }
};

const fetchData = function*(url, action) {
  const options = { method: "get" };
  const params = { url, ...options };
  try {
    const { payload } = yield call(apiCall, params);
    yield put(action(payload));
    return true;
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred getting data"
        }
      ])
    );
    return false;
  }
};

const onDoneAddContact = function*() {
  const recordId = R.last(location.pathname.split("/"));
  const { eventId } = yield call(getParams);
  yield call(
    fetchContactDataWithPage,
    { page: 0 },
    { pageSize: DEFAULT_NOTES_PAGE_SIZE }
  );
};

const deleteGroup = function*({ payload: { contactId } }) {
  const recordId = R.last(location.pathname.split("/"));
  yield put(actions.setLoading(true));
  const {
    eventId,
    credentials: { userId },
    eventDetails
  } = yield call(getParams);
  const records = yield select(getters.records);

  if (!R.length(records) && contactId === "all") {
    yield put(
      registerError([
        {
          system: "empty records",
          user: "You must select at least 1 contact"
        }
      ])
    );
  }

  const url = `/account/${recordId}/contact-relationships`;
  const data = {
    contactIds: contactId === "all" ? records : [contactId]
  };
  const options = { method: "delete", data: { ...data } };
  const params = { url, ...options };
  try {
    const { payload } = yield call(apiCall, params);

    yield put(showSnackbar({ message: "Contact was deleted" }));
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred when deleting the contacts"
        }
      ])
    );
  } finally {
    yield all([
      put(actions.setLoading(false)),
      put(actions.setRecords([])),
      call(
        fetchContactDataWithPage,
        { page: 0 },
        { pageSize: DEFAULT_NOTES_PAGE_SIZE }
      )
    ]);
  }
  return true;
};

const openContact = function*({ payload: { contactId = "" } }) {
  const {
    eventId,
    credentials: { userId },
    eventDetails
  } = yield call(getParams);
  const records = yield select(getters.records);
  if (contactId === "all") {
    if (!R.length(records)) {
      yield put(
        registerError([
          {
            system: "empty records",
            user: "You must select at least 1 contact"
          }
        ])
      );
    }
    R.forEach(record => {
      const url = `${window.__LENND_APP_URL__}/event-light/${eventId}/contact/${record}`;
      window.open(url, "_blank");
    })(records);
    return true;
  }
  const url = `${window.__LENND_APP_URL__}/event-light/${eventId}/contact/${contactId}`;
  return yield call(window.open, url, "_blank");
};

const sendEmail = function*({ payload: { contactId = "" } }) {
  const handleCreate = yield call(makeFuture);
  const records = yield select(getters.records);

  if (!R.length(records) && contactId === "all") {
    yield put(
      registerError([
        {
          system: "empty records",
          user: "You must select at least 1 contact"
        }
      ])
    );
  }
  yield put(
    showModal({
      content: (
        <SendEmailModal
          moduleId={moduleIdForEmails}
          records={contactId === "all" ? records : [contactId]}
          onDone={() => {}}
          selectedOptioans={[SEND_TO_OPTION_TYPES.EMAIL_FIELD]}
        />
      ),
      wrapper: ModalWrapper
    })
  );

  return yield all([
    call(handleCreate.onRealized),
    put(actions.setRecords([]))
  ]);
};

const addContact = function*() {
  const handleIssuance = makeFuture();
  const records = yield select(getters.records);
  const { name = "", type = "Sponsor" } = yield select(
    contactGroupGetters.contactData
  );

  const contactsList = yield select(getters.contactsList);
  const accountId = R.last(location.pathname.split("/"));
  yield put(
    showModal({
      content: (
        <PrimaryContactsModal
          groupId={accountId}
          groupName={name}
          recordTypeName={type.charAt(0).toUpperCase() + type.slice(1)}
          recordTypeColor="#db574b"
          recordTypeIcon="attach_money"
          onDone={() => {
            handleIssuance.done({ type: "done" });
          }}
        />
      ),
      wrapper: ModalWrapper
    })
  );
  return yield call(handleIssuance.onRealized);
};

const handleAddContact = function*({ payload: { contactId = "" } }) {
  const result = yield call(addContact);
  if (result?.type === "done") {
    yield put(actions.setLoading(false));
    try {
      yield call(onDoneAddContact);
    } finally {
      yield put(actions.setLoading(false));
    }
  }
};

const setOrRemovePrimaryContact = function*({
  payload: { contactId = "", isPrimary = false }
}) {
  const accountId = R.last(location.pathname.split("/"));
  yield put(actions.setLoading(true));
  const {
    eventId,
    credentials: { userId },
    eventDetails
  } = yield call(getParams);

  const url = `/account/${moduleId}/contact-relationships/${contactId}`;

  const data = {
    accountId,
    eventId,
    isPrimary: !isPrimary,
    contactId
  };
  const options = { method: "put", data: { ...data } };
  const params = { url, ...options };
  try {
    yield call(apiCall, params);
    yield put(
      showSnackbar({
        message: `Contact was ${
          data.isPrimary ? "added" : "removed"
        } as primary`
      })
    );
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: `An error occurred when ${
            data.isPrimary ? "adding" : "removing"
          } a contact as primary`
        }
      ])
    );
  } finally {
    yield all([
      put(actions.setLoading(false)),
      put(actions.setRecords([])),
      call(
        fetchContactDataWithPage,
        { page: 0 },
        { pageSize: DEFAULT_NOTES_PAGE_SIZE }
      )
    ]);
  }
  return true;
};

const deleteContact = function*({ payload: { contactId } }) {
  const records = yield select(getters.records);
  yield put(actions.setLoading(true));
  const {
    eventId,
    credentials: { userId },
    eventDetails
  } = yield call(getParams);

  if (!R.length(records) && contactId === "all") {
    yield put(
      registerError([
        {
          system: "empty records",
          user: "You must select at least 1 contact"
        }
      ])
    );
  }

  const url = `/modules/${moduleId}/record?eventId=${eventId}&userId=${userId}`;

  const data = {
    bulk: true,
    moduleId: moduleId,
    eventId: eventId,
    records:
      contactId === "all"
        ? R.map(record => ({
            id: record
          }))(records)
        : [{ id: contactId }],
    options: {
      eventId: eventId,
      removeOnly: false
    }
  };
  const options = { method: "delete", data: { ...data } };
  const params = { url, ...options };
  try {
    const { payload } = yield call(apiCall, params);

    yield put(showSnackbar({ message: "Contact was deleted" }));
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred when deleting a note"
        }
      ])
    );
  } finally {
    yield all([
      put(actions.setLoading(false)),
      put(actions.setRecords([])),
      call(
        fetchContactDataWithPage,
        { page: 0 },
        { pageSize: DEFAULT_NOTES_PAGE_SIZE }
      )
    ]);
  }
  return true;
};

const giveAccessPortal = function*({ payload: { contactId = "" } }) {
  const accountId = R.last(location.pathname.split("/"));
  yield put(actions.setLoading(true));
  const {
    eventId,
    credentials: { userId },
    eventDetails
  } = yield call(getParams);

  const url = `/portal/event/${eventId}/users/contacts?userId=${userId}`;

  const data = {
    contacts: [{ contactId, accountId }],
    save: true
  };
  const options = { method: "put", data: { ...data } };
  const params = { url, ...options };
  try {
    const { payload } = yield call(apiCall, params);

    yield put(showSnackbar({ message: "Login access granted" }));
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred"
        }
      ])
    );
  } finally {
    yield all([
      put(actions.setLoading(false)),
      put(actions.setRecords([])),
      call(
        fetchContactDataWithPage,
        { page: 0 },
        { pageSize: DEFAULT_NOTES_PAGE_SIZE }
      )
    ]);
  }
  return true;
};

const removeAccessPortal = function*({ payload: { accountUserId = "" } }) {
  const accountId = R.last(location.pathname.split("/"));
  yield put(actions.setLoading(true));
  const {
    eventId,
    credentials: { userId },
    eventDetails
  } = yield call(getParams);

  const url = `/account/${accountId}/users/${accountUserId}?userId=${userId}`;

  const data = {
    accountId,
    userId: accountUserId,
    eventId
  };
  const options = { method: "delete", data: { ...data } };
  const params = { url, ...options };
  try {
    const { payload } = yield call(apiCall, params);

    yield put(showSnackbar({ message: "Login access has been removed" }));
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred"
        }
      ])
    );
  } finally {
    yield all([
      put(actions.setLoading(false)),
      put(actions.setRecords([])),
      call(
        fetchContactDataWithPage,
        { page: 0 },
        { pageSize: DEFAULT_NOTES_PAGE_SIZE }
      )
    ]);
  }
  return true;
};

const watchMenuAction = function*() {
  for (;;) {
    const action = yield take(actions.executeAction.type);
    const contactId = action.payload.contactId;
    const delegate = R.prop(action.payload.actionId, {
      [CONTACT_ACTIONS.OPEN]: openContact,
      [CONTACT_ACTIONS.DELETE_GROUP]: deleteGroup,
      [CONTACT_ACTIONS.DELETE]: deleteContact,
      [CONTACT_ACTIONS.SEND_EMAIL]: sendEmail,
      [CONTACT_ACTIONS.REMOVE_OR_PRIMARY]: setOrRemovePrimaryContact,
      [CONTACT_ACTIONS.ACCESS_PORTAL]: giveAccessPortal,
      [CONTACT_ACTIONS.REMOVE_ACCESS_PORTAL]: removeAccessPortal,
      [CONTACT_ACTIONS.ADD_CONTACT]: handleAddContact
    });

    if (delegate) {
      yield fork(delegate, action, contactId);
    }
  }
};

const watchFetchContactDataWithPage = function*() {
  yield takeEvery(
    actions.fetchContactDataWithPage.type,
    fetchContactDataWithPage
  );
};

const watchOnDoneAddContact = function*() {
  yield takeEvery(actions.onDoneAddContact.type, onDoneAddContact);
};

const watchInitFetchContactData = function*() {
  yield takeEvery(actions.initFetchContactData.type, initFetchContactData);
};

const rootSaga = function*() {
  yield all([
    fork(initFetchContactData),
    fork(watchMenuAction),
    fork(watchOnDoneAddContact),
    fork(watchFetchContactDataWithPage)
  ]);
};

export default rootSaga;
